
import Is from "./Is";
import type ILegacyApi from "./interfaces/ILegacyApi";
import Semantic from "./Semantic";
import type IApi from "./interfaces/IApi";

const {
    is,
    $array,
    $object,
    $number,
    $string,
    $boolean,
    $undefined,
    $function,
    $null
} = Is;

const {
    $primitive,
    $empty,
    $numeric
} = Semantic

const api : ILegacyApi & IApi = {
    types: Is,
    semantic: Semantic,
    is,
    $object,
    $array,
    $number,
    $string,
    $boolean,
    $undefined,
    $function,
    $null,
    $empty,
    $numeric,
    $primitive
};

export default api;